export {default as styles} from './Licenses.module.scss'